import { Box, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

/** Headline label: dimmed until hovered, matching the other banner blocks. */
export const StyledTitle = styled(Text)`
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

export const StyledDimmedText = styled(Text)`
  opacity: 0.5;
`;

export const StyledDot = styled(Box)`
  opacity: 0.5;
`;
export const StyledArrowWrapper = styled(Box)`
  opacity: 0.5;
  transition: opacity 0.35s;
`;

export const StyledPreviousInvoiceRow = styled(Box)`
  cursor: pointer;
  /*It should support white labeling, it just maybe background brighter*/
  background-color: rgba(255, 255, 255, 0.05);
  &:hover {
    background-color: rgba(255, 255, 255, 0.07);
  }
`;

export const StyledFullWidthLink = styled(Box)`
  a {
    display: block;
    width: 100%;
  }
  &:hover {
    ${StyledArrowWrapper} {
      opacity: 1;
    }
  }
`;

interface StyledDropdownButtonProps {
  isExpanded?: boolean;
}

export const StyledDropdownButton = styled(RawButton)<StyledDropdownButtonProps>``;

export const StyledDropdownList = styled(Box)`
  max-height: 282px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StyledDropdownPanel = styled(Box)`
  position: fixed;
  z-index: 100;
`;
